<template>
    <div id="partslist-edit-line-page">
        <pre
            class="debug"
            v-if="isDebug"
            >{{ { lineData, newSawline, partslistLineIdParam } }}</pre
        >
        <ui5-button
            @click="save"
            :disabled="saving"
        >
            <spinner v-if="saving" />
            {{ trans('pages.partslist_edit_line.save') }}
        </ui5-button>
        <ui5-button
            @click="back()"
            :disabled="saving"
        >
            {{ trans('pages.partslist_edit_line.cancel') }}
        </ui5-button>
        <div class="clearer" />
        <div class="subtitle">
            {{ trans('pages.partslist_edit_line.length_and_count') }}
        </div>
        <div class="fields">
            <div class="field">
                <ui5-label for="profilelength">
                    {{ trans('pages.partslist_edit_line.length') }}
                </ui5-label>
                <text-input
                    type="number"
                    :disabled="saving"
                    id="profilelength"
                    v-if="lineData"
                    v-model="lineData.length"
                    :placeholder="trans('pages.partslist_edit_line.length')"
                />
            </div>
            <div class="field">
                <ui5-label for="profilecount">
                    {{ trans('pages.partslist_edit_line.count') }}
                </ui5-label>
                <text-input
                    type="number"
                    :disabled="saving"
                    v-if="lineData"
                    id="profilecount"
                    v-model="lineData.count"
                    :placeholder="trans('pages.partslist_edit_line.count')"
                />
            </div>
        </div>
        <div class="subtitle">
            {{ trans('pages.partslist_edit_line.select_profile') }}
        </div>
        <div>
            {{ trans('pages.partslist_edit_line.selected_profile') }}
            <span
                id="profileDescr"
                v-if="lineData"
            >
                {{ lineData.code }} - {{ lineData.description }}
            </span>
        </div>
        <profile-search
            :disabled="saving"
            :profile-selected="profileSelected"
        />

        <span class="subtitle">
            {{ trans('pages.partslist_edit_line.sawlines') }}
        </span>
        <table
            cellspacing="0"
            cellpadding="0"
            class="modern-table"
        >
            <thead>
                <tr>
                    <th
                        class="product-table-header-td"
                        align="center"
                    >
                        {{ trans('pages.partslist_edit_line.product_number') }}
                    </th>
                    <th
                        class="product-table-header-td"
                        align="center"
                    >
                        {{ trans('pages.partslist_edit_line.part_of_line') }}
                    </th>
                    <th
                        class="product-table-header-td"
                        align="center"
                    >
                        {{ trans('pages.partslist_edit_line.length') }}
                    </th>
                    <th
                        class="product-table-header-td"
                        align="center"
                    >
                        {{ trans('pages.partslist_edit_line.action') }}
                    </th>
                </tr>
            </thead>
            <tbody v-if="lineData && lineData.sawlist">
                <tr v-for="(sawline, sawlineIndex) in lineData.sawlist">
                    <td align="center">
                        {{ sawline.productNr }}
                        <span
                            class="error"
                            v-if="sawline.error"
                        >
                            {{
                                trans(
                                    'pages.partslist_edit_line.product_not_exists'
                                )
                            }}
                        </span>
                    </td>
                    <td align="center">{{ sawline.partOfLength }}</td>
                    <td align="center">{{ sawline.length }}</td>
                    <td align="center">
                        <i
                            class="fa fa-times"
                            @click="
                                saving
                                    ? (() => {})()
                                    : $delete(lineData.sawlist, sawlineIndex)
                            "
                        />
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="fields">
            <div class="field">
                <ui5-label for="sawline-product-id">
                    {{ trans('pages.partslist_edit_line.product_number') }}:
                </ui5-label>
                <ui5-input
                    type="Text"
                    :disabled="saving"
                    :value="newSawline.productId"
                    @input="newSawline.productId = $event.target.value"
                    id="sawline-product-id"
                    :placeholder="
                        trans('pages.partslist_edit_line.product_number')
                    "
                />
            </div>
            <div class="field">
                <ui5-label for="sawline-part-of-length">
                    {{ trans('pages.partslist_edit_line.part_of_line') }}:
                </ui5-label>
                <ui5-slider
                    min="0"
                    max="10"
                    step="1"
                    id="sawline-part-of-length"
                    :disabled="saving"
                    @change="newSawline.partOfLength = $event.target.value"
                    :value="newSawline.partOfLength"
                    label-interval="1"
                    show-tickmarks
                />
            </div>
            <div class="field">
                <ui5-label for="sawline-length">
                    {{ trans('pages.partslist_edit_line.length') }}:
                </ui5-label>
                <text-input
                    type="number"
                    id="sawline-length"
                    :disabled="saving"
                    v-model="newSawline.length"
                    :placeholder="trans('pages.partslist_edit_line.length')"
                    min="0"
                />
            </div>
        </div>
        <ui5-button
            @click="addSawline"
            :disabled="saving"
        >
            {{ trans('pages.partslist_edit_line.add') }}
        </ui5-button>
    </div>
</template>
<script>
import IsDebugMixin from '../mixins/is-debug';
import IdParamMixin from '../mixins/id-param';
import ProfileSearch from '../components/profiles/ProfileSearch';
import Spinner from '../components/loader/Spinner';
import { stripNonNumeric } from '../helpers/StringHelpers';
import sawlistApi from '../api/sawlist';
import profileApi from '../api/profile';
import partslistApi from '../api/partslist';
import { isNumber } from '../helpers/GeneralHelper';
import { showErrorMessage } from '../dialogs';
import localization from '../mixins/localization';
import TextInput from '../components/TextInput';

export default {
    components: { ProfileSearch, Spinner, TextInput },
    mixins: [
        IsDebugMixin,
        IdParamMixin(
            'productIdParam',
            'partslistIdParam',
            'partslistLineIdParam'
        ),
        localization,
    ],
    mounted() {
        if (!this.partslistLineIdParam) {
            this.lineData.paintlistrecordId = this.partslistLineIdParam;
            this.lineData.paintlistId = this.partslistIdParam;
        }
        this.load();
    },
    computed: {
        productIdParam() {
            return this.$route.params.productId || null;
        },
        partslistIdParam() {
            return this.$route.params.partslistId || null;
        },
        partslistLineIdParam() {
            return this.$route.params.partslistLineId || null;
        },
    },
    data() {
        return {
            saving: false,
            lineData: {
                paintlistrecordId: null,
                paintlistId: null,
                sawlist: [],
                count: '0',
                length: '0',
                profile: null,
                code: '',
                description: '',
            },
            newSawline: {
                productId: '',
                partOfLength: 1,
                length: 0,
            },
        };
    },
    methods: {
        back() {
            this.$router.push(
                '/partslistedit/' +
                    this.productIdParam +
                    '/' +
                    this.partslistIdParam
            );
        },
        profileSelected(profile) {
            if (this.saving) {
                return;
            }
            this.lineData.profile = profile.profileId;
            this.lineData.code = profile.code;
            this.lineData.description = profile.description;
            if (this.lineData.length === '') {
                this.lineData.length = profile.length;
            }
        },
        load() {
            if (this.partslistLineIdParam) {
                sawlistApi
                    .fetchSawlinesForPartslistRecord(this.partslistLineIdParam)
                    .then((response) => {
                        const lineData = response.data.data;

                        lineData.sawlist.forEach((sawline) => {
                            sawline.length = sawline.value;
                        });

                        this.lineData = lineData;
                    })
                    .catch(() => {
                        showErrorMessage(
                            this.trans(
                                'pages.partslist_edit_line.fetch_partslist_line_error'
                            )
                        );
                    });
                this.$store.commit(
                    'general/setPageTitle',
                    `${this.trans(
                        'pages.partslist_edit_line.edit_partslist_line'
                    )} ${this.partslistLineIdParam}, ${this.trans(
                        'pages.partslist_edit_line.partslist'
                    )} ${this.partslistIdParam}`,
                    { root: true }
                );
            } else {
                this.$store.commit(
                    'general/setPageTitle',
                    `${this.trans(
                        'pages.partslist_edit_line.new_partslist_line'
                    )} ${this.partslistIdParam}`,
                    { root: true }
                );
            }
        },
        save() {
            const profileId = this.lineData.profile;
            const count = this.lineData.count;
            const length = this.lineData.length;

            if (!isNumber(profileId) || !isNumber(count) || !isNumber(length)) {
                return showErrorMessage(
                    this.trans('pages.partslist_edit_line.fill_all_fields')
                );
            }
            this.saving = true;

            const payload = {
                partslistId: this.partslistIdParam,
                profileId,
                count,
                length,
                sawlines: this.lineData.sawlist,
                recordId: this.partslistLineIdParam || undefined, //Only used for updateRecord
            };

            const promise = this.partslistLineIdParam
                ? partslistApi.updateRecord(payload)
                : partslistApi.addRecord(payload);

            promise
                .then((response) => {
                    this.back();
                })
                .catch((error) => {
                    const errors = error.response.data;
                    if (errors) {
                        const invalidProducts = errors.map((error) => {
                            if (error.code == 'product.noexists') {
                                return error.extra;
                            }
                        });

                        this.lineData.sawlist.forEach((sawline) => {
                            sawline.error =
                                invalidProducts.indexOf(sawline.productId) >= 0;
                        });
                    }
                    showErrorMessage(
                        this.trans('pages.partslist_edit_line.save_error')
                    );
                })
                .finally(() => {
                    this.saving = false;
                });
        },
        addSawline() {
            const productId = stripNonNumeric(this.newSawline.productId);

            if (!productId.length) {
                return showErrorMessage(
                    this.trans('pages.partslist_edit_line.enter_product_number')
                );
            }

            this.lineData.sawlist.push({
                productId,
                productNr: 'PR' + productId,
                partOfLength: this.newSawline.partOfLength,
                length: this.newSawline.length,
            });

            this.newSawline.productId = '';
            this.newSawline.partOfLength = 1;
        },
    },
};
</script>
